import api from "../axios/axios-config";

export const hearAboutUs = async () => {
	try {
		let response = await api.get("hearAboutUs/listHearAboutUs", {
			headers: {
				Authorization: localStorage.getItem("token"),
			},
		});
		return response?.data?.data;
	} catch (error) {
		console.log("ERROR", error);
		return error?.response?.data;
	}
};

export const getPatients = async () => {
	try {
		let response = await api.get("patient/listOfPatient", {
			headers: {
				Authorization: localStorage.getItem("token"),
			},
		});
		return response?.data?.data.reverse();
	} catch (error) {
		console.log("ERROR", error);
		return error?.response?.data;
	}
};

export const addPatients = async (
	data,
	status,
	isMember,
	receiveMarketingInfo,
) => {
	console.log({ data, status, isMember, receiveMarketingInfo });
	let patientProfile = data;
	try {
		let response = await api.post(
			"patient/addPatient",
			{
				patientProfile,
				isMember,
				isActive: status,
				receiveMarketingInfo,
			},
			{
				headers: {
					Authorization: localStorage.getItem("token"),
				},
			},
		);
		return response?.data?.data;
	} catch (error) {
		console.log("ERROR", error);
		return error?.response?.data;
	}
};

export const modifyPatientCI = async (
	patientID,
	email,
	contactNo,
	preferredContact,
	country,
	city,
	address,
	postalCode,
) => {
	let contactInfo = {
		email,
		contactNo,
		preferredContact,
		country,
		city,
		address,
		postalCode,
	};
	try {
		let response = await api.post(
			"patient/updatePatient",
			{
				patientID,
				contactInfo,
			},
			{
				headers: {
					Authorization: localStorage.getItem("token"),
				},
			},
		);

		return response?.data?.data;
	} catch (error) {
		console.log("ERROR", error);
		return error?.response?.data;
	}
};

export const modifyPatientEC = async (patientID, name, relation, contactNo) => {
	let emergencyContact = {
		name,
		relation,
		contactNo,
	};
	try {
		let response = await api.post(
			"patient/updatePatient",
			{
				patientID,
				emergencyContact,
			},
			{
				headers: {
					Authorization: localStorage.getItem("token"),
				},
			},
		);
		return response?.data?.data;
	} catch (error) {
		console.log("ERROR", error);
		return error?.response?.data;
	}
};

export const modifyPatientMembership = async (patientID, membershipInfo) => {
	try {
		let response = await api.post(
			"patient/updatePatient",
			{
				patientID,
				points: membershipInfo.points,
				pointsExpiry: membershipInfo.pointsExpiry,
			},
			{
				headers: {
					Authorization: localStorage.getItem("token"),
				},
			},
		);
		return response?.data?.data;
	} catch (error) {
		console.log("ERROR", error);
		return error?.response?.data;
	}
};

export const modifyPatientMI = async (patientID, medicalInfo) => {
	try {
		let response = await api.post(
			"patient/updatePatient",
			{
				patientID,
				medicalInfo,
			},
			{
				headers: {
					Authorization: localStorage.getItem("token"),
				},
			},
		);
		return response?.data?.data;
	} catch (error) {
		console.log("ERROR", error);
		return error?.response?.data;
	}
};

export const modifyPatientGI = async (
	patientID,
	apiData,
	status,
	isMember,
	receiveMarketingInfo,
) => {
	try {
		let patientProfile = apiData;
		let response = await api.post(
			"patient/updatePatient",
			{
				patientID,
				patientProfile,
				isMember,
				receiveMarketingInfo,
				isActive: status,
			},
			{
				headers: {
					Authorization: localStorage.getItem("token"),
				},
			},
		);
		return response?.data?.data;
	} catch (error) {
		console.log("ERROR", error);
		return error?.response?.data;
	}
};

export const deletePatient = async (patientID) => {
	try {
		let response = await api.post(
			"patient/updatePatient",
			{
				patientID,
				isDeleted: true,
			},
			{
				headers: {
					Authorization: localStorage.getItem("token"),
				},
			},
		);
		return response?.data?.data;
	} catch (error) {
		console.log("ERROR", error);
		return error?.response?.data;
	}
};

export const uploadCsv = async (file) => {
	try {
		let response = await api.post("cvsImport/importPatientFromCSV", file, {
			headers: {
				Authorization: localStorage.getItem("token"),
				"content-type": "multipart/form-data",
			},
		});

		return response?.data?.data;
	} catch (error) {
		console.log("ERROR", error);
		return error?.response?.data;
	}
};

export const updatePatientProfileImage = async (patientID, file) => {
	try {
		let fd = new FormData();
		fd.append("image", file);
		fd.append("id", patientID);

		let response = await api.post("patient/updatePatientProfileImage", fd, {
			headers: {
				Authorization: localStorage.getItem("token"),
				"Content-Type": "multipart/form-data",
			},
		});

		return response.data;
	} catch (error) {
		console.log("ERROR", error);
		return error?.response?.data;
	}
};

export const getPatientsByDoctorId = async (doctorId) => {
	try {
		let response = await api.post(
			"users/listOfPatientByDocId",
			{
				doctorId,
			},
			{
				headers: {
					Authorization: localStorage.getItem("token"),
				},
			},
		);
		return response?.data?.data;
	} catch (error) {
		console.log("ERROR", error);
		return error?.response?.data;
	}
};

export const getPatientDetailsById = async (patientID) => {
	try {
		let response = await api.post(
			"patient/getPatientDeatilsById",
			{
				patientID,
			},
			{
				headers: {
					Authorization: localStorage.getItem("token"),
				},
			},
		);
		return response?.data?.data;
	} catch (error) {
		console.log("ERROR", error);
		return error?.response?.data;
	}
};
